import { render, staticRenderFns } from "./LydiaxSuccess.vue?vue&type=template&id=36a9a3d2&"
import script from "./LydiaxSuccess.vue?vue&type=script&lang=js&"
export * from "./LydiaxSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports